export type Identity = { id: string; name: string; department: "ELECTRICAL" | "MECHANICAL" };
export type PushConfiguration = { configured: boolean; publicKey: string | null };

function record(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}

export function parseMobileIdentity(value: unknown): Identity {
  if (!record(value) || typeof value.id !== "string" || typeof value.name !== "string" ||
    (value.department !== "ELECTRICAL" && value.department !== "MECHANICAL")) {
    throw new Error("Teknik oturum yanıtı geçersiz.");
  }
  return { id: value.id, name: value.name, department: value.department };
}

export function parsePushConfiguration(value: unknown): PushConfiguration {
  if (!record(value) || typeof value.configured !== "boolean" ||
    (value.publicKey !== null && typeof value.publicKey !== "string")) {
    throw new Error("Bildirim ayarı yanıtı geçersiz.");
  }
  return { configured: value.configured, publicKey: value.publicKey };
}
